var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.editor)?_c('EditorContent',{attrs:{"id":"read-only-editor","editor":_vm.editor}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }